import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import type { ServiceCentreAddress } from '@/lib/service/ecs/logisticsCapabilities';

import styles from './RepairRequestServiceCentre.module.scss';

interface RepairRequestServiceCentreProps {
  address: ServiceCentreAddress;
  className?: string;
}

export function RepairRequestServiceCentre({
  address,
  className,
}: Readonly<RepairRequestServiceCentreProps>) {
  const t = useTranslations('service.repairRequest.personal.serviceCentre');

  if (!address.name) {
    return null;
  }

  return (
    <div className={clsx(styles.centre, className)} data-testid="personal-repair-centre-address">
      <p className={styles.name}>{address.name}</p>
      <p>{address.address1}</p>
      {address.address2 ? <p>{address.address2}</p> : null}
      {address.address3 ? <p>{address.address3}</p> : null}
      <p>
        {t('phone')}: {address.phone || '—'}
      </p>
      <p>
        {t('email')}: {address.email || '—'}
      </p>
    </div>
  );
}
